import FormControl from '@mui/material/FormControl';
import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { SelectOptionType } from '../utils/Types';
import { Box, IconButton } from '@mui/material';
import { Label } from 'reactstrap';
import { Search } from 'react-bootstrap-icons';
import classNames from 'classnames';

interface IMAutoCompleteWithIdProps {
  label: string;
  value?: SelectOptionType;
  icon?: React.ReactElement;
  onChange?: (value: any) => void;
  onIconClick?: () => void;
  disabled?: boolean;
  options: SelectOptionType[];
  defaultValue?: SelectOptionType;
  highLightSelectedOption?: boolean;
  showIdInOption?: boolean;
  placeholder?: string;
  blurOnSelect?: boolean;
}
export const getRenderOption = (
  props: any,
  option: SelectOptionType,
  value?: SelectOptionType | undefined,
  showIdInOption?: boolean,
  highLightSelectedOption?: boolean | undefined
) => (
  <Box component="li" sx={{ mr: 2, flexShrink: 0 }} {...props}>
    <div
      className={classNames('d-flex  width-100 p-1', {
        'highlight-option':
          highLightSelectedOption && value?.value === option.value,
      })}
    >
      <Label>{option.label} </Label>{' '}
      {showIdInOption && <Label className="ms-auto ">{option.value}</Label>}
    </div>
  </Box>
);
const MAutoCompleteWithId: React.FunctionComponent<
  IMAutoCompleteWithIdProps
> = ({
  value,
  onChange,
  onIconClick,
  disabled,
  options,
  highLightSelectedOption,
  showIdInOption = true,
  defaultValue,
  placeholder,
  blurOnSelect = false,
}) => {
  return (
    <FormControl fullWidth>
      <Autocomplete
        disablePortal
        id="name-box"
        options={options}
        disabled={disabled}
        value={value}
        defaultValue={defaultValue ?? value}
        blurOnSelect={blurOnSelect}
        onChange={(_event: any, newValue: any) => {
          if (onChange) onChange(newValue);
        }}
        getOptionLabel={(option) => String(option.label)}
        renderOption={(props, option) =>
          getRenderOption(
            props,
            option,
            value,
            showIdInOption,
            highLightSelectedOption
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            hiddenLabel
            id="filled-hidden-label-normal"
            defaultValue=""
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '14px',
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <IconButton disabled={disabled} onClick={onIconClick}>
                  <Search className="p-1" />
                </IconButton>
              ),
            }}
            placeholder={placeholder ?? ''}
          />
        )}
        isOptionEqualToValue={(option, value) => option.value === value.value}
      />
    </FormControl>
  );
};

export default MAutoCompleteWithId;
